export default "__VITE_ASSET__b314547e__"